import externalLinkCall from "./externalLinkCall";
import $ from 'jquery';
import ClipboardJS from 'clipboard';

const shareButton = () => {

    document.addEventListener('click', ev => {
        if (!ev.target.matches('.ume-project-share-button')) return;
        const button = ev.target;
        const target = button.getAttribute('data-target');
        const link = wp_environment.ume_home + '/projekte#' + target;
        const tweetLink = `https://twitter.com/intent/tweet?&url=${link}`;
        const faceLink = `https://www.facebook.com/sharer/sharer.php?u=${link}`

        const socialContainer = document.createElement('div');
        socialContainer.classList.add('d-flex', 'flex-column', 'justify-content-start', 'align-items-center', 'mt-2', 'ume-social-container');


        const faceButton = document.createElement('button');
        const tweetButton = document.createElement('button');
        faceButton.classList.add('ume-social-share')
        faceButton.setAttribute('aria-label', 'Auf Facebook teilen');
        faceButton.setAttribute('title', 'Auf Facebook teilen');
        faceButton.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-square" class="svg-inline--fa fa-facebook-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path></svg> Auf Facebook teilen';
        faceButton.href = faceLink;
        tweetButton.classList.add('ume-social-share')
        tweetButton.setAttribute('aria-label', 'Auf Twitter teilen');
        tweetButton.setAttribute('title', 'Auf Twitter teilen');
        tweetButton.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter-square" class="svg-inline--fa fa-twitter-square fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"></path></svg> Auf Twitter teilen';
        tweetButton.href = tweetLink;


        socialContainer.append(faceButton);
        socialContainer.append(tweetButton);

        const copyID = 'ume-social-' + Math.floor(Date.now());
        const copyButton = document.createElement('button');
        copyButton.setAttribute('data-clipboard-target', '#' + copyID);
        copyButton.setAttribute('data-clipboard-action', 'copy');
        copyButton.classList.add('ume-copy-clipboard', 'ume-social-share');
        copyButton.setAttribute('aria-label', 'Kopieren');
        copyButton.setAttribute('titel', 'Kopieren');
        copyButton.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="copy" class="svg-inline--fa fa-copy fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"></path></svg>Web-Link kopieren';
        const copyField = document.createElement('input');
        copyField.setAttribute('id', copyID);
        copyField.classList.add('ume-copy-field');
        copyField.setAttribute('aria-hidden', 'true');
        copyField.setAttribute('value', link);
        socialContainer.append(copyButton);
        socialContainer.append(copyField);


        const shareBox = document.querySelector('.ume-project-share-options');
        shareBox.innerHTML = '';
        shareBox.append(socialContainer);
        const positionY = $(button).offset().top - $('.ume-content-modal-dialog').offset().top + 50;
        const positionX = $(button).offset().left - $('.ume-content-modal-dialog').offset().left + 52.234375;


        shareBox.classList.toggle('ume-project-share-options__show');
        shareBox.setAttribute('style', `top: ${positionY}px; left: ${positionX}px`);
        new ClipboardJS('.ume-copy-clipboard');
        const listenCLose = (ev) =>{
            if(!ev.target.classList.contains('ume-social-share') || ev.target.classList.contains('ume-project-share-button')){

                if(shareBox.classList.contains('ume-project-share-options__show')){
                    shareBox.classList.remove('ume-project-share-options__show');

                }


            }
        }
        document.addEventListener('click', listenCLose , {once: true} )
        faceButton.addEventListener('click', (ev) => {
            ev.preventDefault();
            externalLinkCall(faceLink);
        });
        tweetButton.addEventListener('click', (ev) => {
            ev.preventDefault();
            externalLinkCall(tweetLink);
        });
        if(!shareBox.classList.contains('ume-project-share-options__show')){
            document.removeEventListener('click', listenCLose);
        }
    })


}
export default shareButton;